import { getLinks, AcceptedLinksStarts } from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next/types'
import { storeStaticPaths } from './data/landing-store-feature.data'

export const getStaticPathsGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    // Get the paths we want to pre-render based on data
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = storeStaticPaths({ links })
      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
